import { Platform } from 'react-native';
import type { ScrollViewProps } from 'react-native';
import type { ButtonProps } from 'react-native-paper';

/**
 * In case an outlined button is used, use this as labelStyle
 */
export const outlinedButtonLabelStyle: ButtonProps['labelStyle'] = {
  marginVertical: 9
};

// Todo: check color when we enable dark mode
// Web style "scrollbarColor" recognized
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
export const webScrollBarStyle: ScrollViewProps['style'] = Platform.select({
  web: { scrollbarColor: 'rgb(139, 139, 139) transparent' }
});
